export const CENTRAL_API_URL_KEY = "centralApiUrl";